export const data = [
  {
    id: 1,
    title:
      "Hardworking and passionate jobseeker with strong organizational skills eager to secure entry-level Web developer position in Front-end environment. Ready to help team achieve company goals.",
  },
];
